<template>
    <div>
        <div>
            <div>
                <div class="catalog-title" style="font-weight: bold">材料目录</div>
                <div class="catalog-title" :class="{ 'catalog-title-active': item.isActive }"
                     v-for="(item, index) in catalogList" :key="index"
                     @click="clickCatalogItem(item, index)">{{ item.name }}
                </div>
            </div>
            <div style="margin-top: 10px">
                <div class="select-materials-label">
                    <span>材料名称：</span>
                </div>
                <div class="select-materials-input">
                    <Input v-model="materialsParam.name"/>
                </div>
                <div class="form-button">
                    <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQueryMaterials">查询</Button>
                </div>
            </div>
            <div style="margin-top: 10px">
                <Table border ref="selectionTable" size="small" :columns="materColumnsShow"
                       :data="showMaterList"
                       :loading="materLoading"
                       @on-row-click="clickShowMaterTable"
                       @on-selection-change="onSelectionChange">
                </Table>
                <div style="margin-top: 10px;text-align: left">
                    <Page v-model="materialsParam.current" :page-size="materialsParam.size"
                          :total="materialsParam.total"
                          @on-change="onMaterialsPageChange"
                          @on-page-size-change="onMaterialsPageSizeChange"
                          show-sizer show-elevator show-total/>
                </div>
            </div>
        </div>
        <div style="text-align: center;margin-top: 10px">
            <Button style="margin-right: 10px" type="primary" @click="selectMaterOk" icon="md-checkmark">确定</Button>
            <Button @click="selectMaterCancel" icon="ios-undo">取消</Button>
        </div>
    </div>
</template>

<script>
import {queryMaterialsCatalogList, queryMaterialsInfoPage} from "@/api/baseData"

export default {
    name: "ChooseMater",
    data() {
        return {
            catalogList: [],
            materialsParam: {
                name: '',
                catalogIds: [],
                total: 0,
                current: 1,
                size: 10,
            },
            materColumnsShow: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center',
                },
                {
                    title: '材料名称',
                    key: 'name',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '所属目录',
                    key: 'catalogName',
                    align: 'center',
                },
                {
                    title: '单位',
                    key: 'unitName',
                    align: 'center',
                },
                {
                    title: '规格',
                    key: 'matSpec',
                    align: 'center',
                },
            ],
            showMaterList: [],
            materLoading: false,
            selectedMaterList: [],
        }
    },
    mounted() {
        this.onQueryMaterials()
        queryMaterialsCatalogList({}).then((res) => {
            this.catalogList = res.data
            const item = {id: 0, name: '全部'}
            this.catalogList.unshift(item)
        })
    },
    methods: {
        onQueryMaterials() {
            if (this.materLoading) {
                return
            }
            this.materLoading = true
            queryMaterialsInfoPage(this.materialsParam).then((res) => {
                this.showMaterList = res.data
                this.materialsParam.current = res.current
                this.materialsParam.total = res.total
                this.selectedMaterList = []
            }).finally(() => {
                this.materLoading = false
            })
        },
        clickCatalogItem(item, index) {
            if (item.id === 0) {
                if (!item.isActive) {
                    for (let i = 0; i < this.catalogList.length; i++) {
                        this.$set(this.catalogList, i, {
                            ...this.catalogList[i],
                            isActive: true,
                        })
                    }
                } else {
                    for (let i = 0; i < this.catalogList.length; i++) {
                        if (i === 0) {
                            this.$set(this.catalogList, i, {
                                ...this.catalogList[i],
                                isActive: true,
                            })
                        } else {
                            this.$set(this.catalogList, i, {
                                ...this.catalogList[i],
                                isActive: false,
                            })
                        }
                    }
                }
            } else {
                this.$set(this.catalogList, index, {
                    ...item,
                    isActive: !item.isActive,
                })
                let hasNotActive = false
                for (let i = 1; i < this.catalogList.length; i++) {
                    if (!this.catalogList[i].isActive) {
                        hasNotActive = true
                    }
                }
                if (hasNotActive) {
                    this.$set(this.catalogList, 0, {
                        ...this.catalogList[0],
                        isActive: false,
                    })
                } else {
                    this.$set(this.catalogList, 0, {
                        ...this.catalogList[0],
                        isActive: true,
                    })
                }
            }
            this.materialsParam.catalogIds = []
            for (let i = 0; i < this.catalogList.length; i++) {
                if (this.catalogList[i].isActive) {
                    this.materialsParam.catalogIds.push(this.catalogList[i].id)
                }
            }
            this.onQueryMaterials()
        },
        clickShowMaterTable(row, index) {
            // 获取表格的ref
            const table = this.$refs.selectionTable
            // 手动设置选中状态
            table.toggleSelect(index)
        },
        onSelectionChange(selectedNodes) {
            this.selectedMaterList = selectedNodes
        },
        onMaterialsPageChange(e) {
            this.materialsParam.current = e
            this.onQueryMaterials()
        },
        onMaterialsPageSizeChange(e) {
            this.materialsParam.current = 1
            this.materialsParam.size = e
            this.onQueryMaterials()
        },
        selectMaterOk() {
            this.$emit('handleClose', this.selectedMaterList)
        },
        selectMaterCancel() {
            this.$emit('handleClose', false)
        },
    },
}
</script>

<style scoped>
.catalog-title {
    display: inline-block;
    margin-right: 2px;
    cursor: pointer;
    padding: 2px 6px;
}

.catalog-title-active {
    background: #73cee8;
    color: #ffffff;
}

.select-materials-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 5px;
}

.select-materials-input {
    display: inline-block;
    width: 200px;
    font-size: 14px;
    margin-right: 15px;
}

.form-button {
    display: inline-block;
}
</style>
